$(() => {
	/**
	 * Navbar superfish mega menu
	 */
	$(".navbar__menu").superfish({
		hoverClass: "sf-hover",
		popUpSelector: ".megamenu, .submenu",
		delay: 300,
		animationOut: { opacity: "hide" },
		speedOut: 0,
	});

	$(".navbar__toggler").on("click", (e) => {
		const $toggler = $(e.currentTarget);
		$toggler.attr(
			"aria-expanded",
			() => $toggler.attr("aria-expanded") === "false"
		);
		$(".navbar__menu-slot").toggleClass("navbar__menu-slot--show");
	});

	// Trigger child and grandchild page flyouts
	$("li.menu-item").on("click", (e) => {
		$(e.currentTarget).addClass("is-active");
	});

	// Prevent clicks on actual menu links from triggering panel flyouts
	$("li.menu-item > a").on("click", (e) => {
		e.stopPropagation();
		e.stopImmediatePropagation();
	});

	// Trigger menu "back" functionality
	$(".submenu-back-btn").on("click", (e) => {
		e.stopPropagation();
		$(e.currentTarget).closest(".is-active").removeClass("is-active");
	});

	$(".mobile-menu-toggle").click(function () {
		let item = $(this).closest("li");

		if (item.hasClass("active")) {
			item.removeClass("active");
		} else {
			item.siblings().removeClass("active");
			item.addClass("active");
		}
	});

	const $menuRoot = $(".navbar__menu");
	const SUPERFISH_DELAY = 300;

	function swapMenuImage($menu, newSrc) {
		const $img = $menu.find(".megamenu__image > a img").first();
		if (!$img.length) return;

		// remember the original src
		if (!$img.data("originalImg")) {
			var origSrc = $img.attr("src") || "";
			var origSet = $img.attr("srcset") || "";
			var origSizes = $img.attr("sizes") || "";
			$img.data("origSrc", origSrc);
			$img.data("origSet", origSet);
			$img.data("origSizes", origSizes);
			$img.data("originalImg", true);
		}

		if (newSrc && newSrc.length) {
			// show product_hover_image
			$img.attr("src", newSrc);
			$img.removeAttr("srcset");
			$img.removeAttr("sizes");
		} else {
			// go back to the original
			var set = $img.data("origSet") || "";
			var sizes = $img.data("origSizes") || "";
			$img.attr("src", $img.data("origSrc") || "");
			if (set.length) {
				$img.attr("srcset", set);
			} else {
				$img.removeAttr("srcset");
			}
			if (sizes.length) {
				$img.attr("sizes", sizes);
			} else {
				$img.removeAttr("sizes");
			}
		}
	}

	// when a submenu item is hovered, swap to its data-hover-src
	$menuRoot.on("mouseenter", ".megamenu .submenu-link", function () {
		var $link = $(this);
		var src = $link.attr("data-hover-src") || "";
		var $menu = $link.closest(".megamenu");
		if (src.length) {
			swapMenuImage($menu, src);
		} else {
			swapMenuImage($menu, null);
		}
	});

	// after the megamenu closes, restore original megamenu__img
	$menuRoot.on("mouseleave", "li.menu-item", function () {
		var $menu = $(this).children(".megamenu").first();
		if (!$menu.length) return;
		setTimeout(function () {
			if (!$menu.is(":visible")) {
				swapMenuImage($menu, null);
			}
		}, SUPERFISH_DELAY + 30);
	});
});
